// extracted by mini-css-extract-plugin
export default {"title":"DeepLinkContent_title_FejLU","text":"DeepLinkContent_text_VUhrY"};